export default "__VITE_ASSET__D4wgeP03__"